module.exports = __webpack_public_path__ + "img/solution-pc-4.b6467b49.png";